import { CanDeactivateFn } from '@angular/router'

/** A routed page that can tell whether leaving it would drop edits. */
export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean
  /** Translated "leave without saving?" prompt. */
  unsavedChangesMessage(): string
}

/** Asks before navigating away from a page with unsaved edits. */
export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = component =>
  !component?.hasUnsavedChanges() || confirm(component.unsavedChangesMessage())
